import _ from 'lodash';
import { createSelector } from 'reselect';

const usersKey="driverPermitListReducer";

export const getDriverPermitListState = (state) => _.get(state, usersKey);
export const driverPermitListStateList = createSelector(getDriverPermitListState, (state) => _.get(state, 'driverPermitListStateList'));
export const driverPermitListStateListError = createSelector(getDriverPermitListState, (state) => _.get(state, 'driverPermitListStateListError'));
export const driverSelectedGridPermit = createSelector(getDriverPermitListState, (state) => _.get(state, 'driverSelectedGridPermit'));
export const driverPermitResion = createSelector(getDriverPermitListState, (state) => _.get(state, 'drivervirtualpermitResionText'));


